import React from 'react';

import PropTypes from 'prop-types';

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { TagSwatch } from '../../../../../../../shared/components/Tag';
import { appointmentShape } from '../../../../../types';
import { formatTime, getAppointmentColor } from '../../../../../utils';

const TIME_STYLES =
  'text-[11px] text-muted-foreground font-semibold shrink-0 w-14 tabular-nums';

const TRIGGER_STYLES = cn(
  'flex w-full items-center justify-center rounded border',
  'bg-muted text-muted-foreground text-[11px] font-semibold'
);

const OverflowMenu = ({ appointments, onAppointmentClick }) => {
  const handleClick = (appointment) => () => onAppointmentClick(appointment);

  return (
    <HoverCard>
      <HoverCardTrigger className={TRIGGER_STYLES}>
        +{appointments.length} more
      </HoverCardTrigger>

      <HoverCardContent align="start" className="w-64 p-0 overflow-hidden">
        <div className="flex flex-col gap-1 p-1 max-h-72 overflow-y-auto">
          {appointments.map((appointment) => (
            <button
              className="flex items-center gap-0.5 px-2 py-1.5 rounded hover:bg-accent"
              key={appointment.id}
              onClick={handleClick(appointment)}
              type="button"
            >
              <TagSwatch color={getAppointmentColor(appointment)} />

              <div className="flex gap-2 items-center">
                <span className={TIME_STYLES}>
                  {formatTime(new Date(appointment.startAt))}
                </span>

                <span className="text-xs font-medium truncate">{appointment.title}</span>
              </div>
            </button>
          ))}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

OverflowMenu.propTypes = {
  appointments: PropTypes.arrayOf(appointmentShape).isRequired,
  onAppointmentClick: PropTypes.func.isRequired,
};

export default OverflowMenu;
